<template>
    <div  class="q-pa-md text-center me"
          @dragover.prevent="() => {}"
          @dragleave="() => {}"
          @dragenter="() => {}"
          @drop="drop">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'DropArea',
        methods: {
            drop (e) {
                this.$emit('dropped', e)
            }
        }
    }
</script>

<style scoped>
    .me {
        color: gray;
        background-color: #fff;
        border: 2px dashed gray;
        width: 100%;
        height: 100%;
    }
</style>